export interface IBarcodeTbl {
	barcodeString?: string;
	barcodeId: number;
	tagNumber?: string;
	unit?: string;
	unitId: number;
	client?: string;
	clientId: number;
	canDelete: boolean;
	isUpdatedOffline: boolean;
	offlineId?: any;
	userId?: number;
};

export class BarcodeTbl implements IBarcodeTbl {
	barcodeString = '';
	barcodeId = 0;
	tagNumber = '';
	unit = '';
	unitId = 0;
	client = '';
	clientId = 0;
	canDelete = false;
	isUpdatedOffline = false;
	offlineId = '';
	userId = 0;
};
